import api from '../../api';
import moment from 'moment';

// initial state
const state = {
    onLoading: true,
    data: [],
    pagination: {
        limit: 5,
        offset: 0,
        total: 0,
        showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20'],
        pageSize: 5
    }
};

// getters
const getters = {};

// actions
const actions = {
    index({ commit, state }, query = {}) {
        commit('setOnLoading', true);
        query['findBy-type'] = 'eq,type,propertyAdvertisement,string';
        return api
            .advertisementIndex({
                offset: state.pagination.offset,
                limit: state.pagination.limit,
                ...query
            })
            .then(res => {
                commit('setOnLoading', false);
                commit('setData', res.data.data);
                commit('setPagination', res.data.meta);
                return res;
            });
    },
    // eslint-disable-next-line
    show({ commit }, id) {
        return api.advertisementShow(id);
    },
    // eslint-disable-next-line
    createPropertyAd({ commit }, payload) {
        return api.advertisementCreatePropertyAd(payload).then(res => {
            return res;
        });
    },
    // eslint-disable-next-line
    createProjectAd({ commit }, payload) {
        return api.advertisementCreateProjectAd(payload).then(res => {
            return res;
        });
    },
    verify({ commit }, payload) {
        let { id, entity } = payload;
        return api.advertisementVerify(id, entity).then(res => {
            commit('changeStatusById', {
                id,
                status: 'verified'
            });
            return res;
        });
    },
    deny({ commit }, payload) {
        let { id, entity } = payload;
        return api.advertisementDeny(id, entity).then(res => {
            commit('changeStatusById', {
                id,
                status: 'denied'
            });
            return res;
        });
    },
    // meta
    setPagination({ commit }, payload) {
        return new Promise(resolve => {
            commit('setPagination', payload);
            resolve(true);
        });
    }
};

// mutations
const mutations = {
    setData(state, data) {
        state.data = data;
    },
    setOnLoading(state, loadingStatus) {
        state.onLoading = loadingStatus;
    },
    setPagination(state, meta) {
        state.pagination.offset = meta.offset;
        state.pagination.limit = meta.limit;
        state.pagination.total = meta.total;

        state.pagination.pageSize = meta.limit;
    },
    updateDataById(state, data) {
        let index = state.data.indexOf(n => n.id === data.id);
        if (index !== -1) {
            state.data[index] = data;
        }
    },
    changeStatusById(state, payload) {
        let index = state.data.findIndex(n => n.id === payload.id);
        if (index !== -1) {
            state.data[index].status = payload.status;
            if (payload.status === 'verified') {
                state.data[index].verifiedAt = moment().toISOString();
            }
        }
    },
    removeDataById(state, id) {
        let index = state.data.indexOf(n => n.id === id);
        state.data.splice(index, 1);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
